/*export default {
 script: {
 allow: (service) =>
 {
 const els = document.querySelectorAll('iframe[data-service="' + service + '"]')
 
 els.forEach(_ =>
 {
 _.src = service.src
 })
 },
 decline: (service) =>
 {
 
 }
 },
 iframe: {
 allow: (service) =>
 {
 const els = document.querySelectorAll('iframe[data-service="' + service + '"]')
 
 els.forEach(_ =>
 {
 _.src = service.src
 })
 },
 decline: (service) =>
 {
 const els = document.querySelectorAll('iframe[data-service="' + service + '"]')
 
 els.forEach(_ =>
 {
 _.src = ''
 })
 }
 }
 }*/

export default class Manager
{
	addScript (service, src)
	{
		const el = document.createElement('script')
		
		el.type = 'text/javascript'
		el.async = true
		el.src = src
		el.dataset.service = service
		
		document.body.append(el)
	}
	
	addInlineScript (service, script)
	{
		const el = document.createElement('script')
		
		el.innerHTML = script
		el.dataset.service = service
		
		document.body.append(el)
	}
	
	removeScript (service)
	{
		const scripts = Array.from(document.getElementsByTagName('script'))
		
		scripts.forEach(_ =>
		{
			if (_.dataset.service === service)
			{
				_.remove()
			}
		})
	}
	
	addIframe (service, src)
	{
		const els = document.querySelectorAll('div[data-rgpd="' + service + '"]')
		
		els.forEach(el =>
		{
			const iframe = document.createElement('iframe')
			
			iframe.src = src
			
			el.append(iframe)
		})
	}
	
	removeIframe (service)
	{
		const els = document.querySelectorAll('div[data-rgpd="' + service + '"]')
		
		els.forEach(el =>
		{
			const iframe = el.querySelector('iframe')
			
			if (iframe)
			{
				iframe.remove()
			}
		})
	}
}
